import { z } from "zod";

export const getUserAbsencesSchema = z.object({
	startDate: z.string(),
	endDate: z.string(),
});

export type GetUserAbsencesSchema = z.infer<typeof getUserAbsencesSchema>;
